export default __webpack_public_path__ + "static/donate-coin-3226e2cba407b030ceb5403950832421.png";